import { render, staticRenderFns } from "./CompetitionDialog.vue?vue&type=template&id=6389b7f7"
import script from "./CompetitionDialog.vue?vue&type=script&lang=js"
export * from "./CompetitionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports